module.exports = __webpack_public_path__ + "static/media/img02.97d626d9.png";